import { Breakpoints } from 'styled/tools/breakpoints';
import { pxToEm } from './units';

export const mediaQuery = (
  breakpoint: keyof typeof Breakpoints,
  comparison: 'min' | 'max' = 'min',
  dimension: 'width' | 'height' = 'width',
) => {
  let bp: string;
  if (comparison === 'max') {
    bp = pxToEm(Breakpoints[breakpoint] - 1);
  } else {
    bp = pxToEm(Breakpoints[breakpoint]);
  }
  return `(${comparison}-${dimension}: ${bp})`;
};

export const mqXSmallMax = mediaQuery('xs', 'max');
export const mqSmallMin = mediaQuery('s');
export const mqSmallMax = mediaQuery('s', 'max');
export const mqMediumMin = mediaQuery('m');
export const mqMediumMax = mediaQuery('m', 'max');
export const mqTabletMax = mediaQuery('tb', 'max');
export const mqTabletMin = mediaQuery('tb2');
export const mqTablet2Max = mediaQuery('tb2', 'max');
export const mqLargeMin = mediaQuery('l');
export const mqLargeMax = mediaQuery('l', 'max');
export const mqSXLargeMin = mediaQuery('sxl');
export const mqSXLargeMax = mediaQuery('sxl', 'max');
export const mqXLargeMin = mediaQuery('xl');
export const mqXXLargeMin = mediaQuery('xxl');
export const mqXXLargeMax = mediaQuery('xxl', 'max');
